// Compact number formatting that mirrors the YouTube/casino style.
// 0..999 → as-is; 1_000+ → 1K; 1_000_000 → 1M; 1_000_000_000 → 1B; 1e12 → 1T; 1e15 → 1Q.
// Keeps at most one decimal (drops trailing .0).
export function formatCompact(n, opts = {}) {
  if (n == null || isNaN(n)) return '—';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  const fix = (x) => {
    const s = x.toFixed(1);
    return s.endsWith('.0') ? s.slice(0, -2) : s;
  };
  if (abs < 1000) return sign + (Number.isInteger(n) ? String(abs) : fix(abs));
  if (abs < 1e6) return sign + fix(abs / 1e3) + 'K';
  if (abs < 1e9) return sign + fix(abs / 1e6) + 'M';
  if (abs < 1e12) return sign + fix(abs / 1e9) + 'B';
  if (abs < 1e15) return sign + fix(abs / 1e12) + 'T';
  return sign + fix(abs / 1e15) + 'Q';
}

// Currency variant with leading symbol.
export function formatMoneyCompact(n, symbol = '₹') {
  return `${symbol}${formatCompact(n)}`;
}
